import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { BreadcrumbListProps } from "../types";

function BreadcrumbList({ className, ...props }: BreadcrumbListProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <ol
      data-slot="breadcrumb-list"
      className={cn(
        "text-muted-foreground flex flex-wrap items-center gap-1.5 text-sm break-words sm:gap-2.5",
        className,
        classes,
      )}
      {...native}
    />
  );
}

BreadcrumbList.displayName = "Breadcrumb.List";

export default BreadcrumbList;
